<template>
  <AtomicUiSlideout id="sort-and-filter" title="Sort & Filter" position="right" :sticky-header="true" @close-slideout="closeSlideout">
    <div class="grid-x grid-margin-x margin-bottom-s sticky-buttons">
      <div class="cell small-6">
        <button class="secondary button expanded" :disabled="clearDisabled" @click.prevent="clearAllSelectedFacets">Clear All</button>
      </div>
      <div class="cell small-6">
        <button class="primary button expanded" @click.prevent="applyFilter">Apply</button>
      </div>
    </div>

    <FilteringFacetsSortByCriteria />

    <p class="large margin-top-m margin-bottom-s">Filter By</p>

    <FilteringFacetsCriteriaWrapper v-if="selectionsFacets.length" :name="selectionsFacets[0].id" />
  </AtomicUiSlideout>
</template>

<script setup>
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

const slideoutStore = useSlideoutStore();
const filteringFacetsStore = useFilteringFacetsStore();
const { resetSelections, selections, clearAllSelectedFacets } = useSortFilter();

const closeSlideout = () => {
  resetSelections();
};

const selectionsFacets = computed(() =>
  selections.value.facets.map((facet) => ({
    id: facet.name,
  })),
);

const clearDisabled = computed(() => selections.value.facets.filter((facet) => (facet.selectedValues || []).length > 0).length === 0);

const applyFilter = () => {
  slideoutStore.close('sort-and-filter');
  filteringFacetsStore.updateSortBySelected(selections.value.sortBySelectedValue);
  selections.value.facets.forEach((facet) => {
    if (facet.name === 'Price') {
      const customPrice = facet.values.filter((value) => value.label.indexOf('Custom:') > -1);
      if (customPrice.length > 0) {
        filteringFacetsStore.addCheckboxValues({
          name: facet.name,
          newValue: {
            label: customPrice[0].label,
            value: customPrice[0].value,
          },
        });
      }
      filteringFacetsStore.replaceSelectedValues({
        name: facet.name,
        selectedValues: facet.selectedValues,
      });
    } else {
      filteringFacetsStore.replaceSelectedValues({
        name: facet.name,
        selectedValues: facet.selectedValues,
      });
    }
  });
  filteringFacetsStore.getAllSelectedCriteria();
};
</script>

<style lang="scss" scoped>
.sticky-buttons {
  position: sticky;
  padding-bottom: rem-calc(20);
  top: rem-calc(92);
  z-index: 30;
  background: $white;
}
</style>
